(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[786],{

/***/ 54575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/register.html",
      function () {
        return __webpack_require__(36747);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31567);
/* harmony import */ var _store_selectors_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18851);





var HeaderTitle = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    var chunks = [];
    var title = typeof props.children == "object" ? props.children.join("") : props.children;
    var env = _store_selectors_settings__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getEnv */ .Z.getEnv();
    if (env == "dev") {
        chunks.push("[DEV]");
    }
    if (env == "stg") {
        chunks.push("[STG]");
    }
    chunks.push(title);
    chunks.push(t("meta_title_suffix"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: chunks.join(" | ")
        })
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (HeaderTitle);


/***/ }),

/***/ 76297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AcceptanceTermsCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50480);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69368);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46901);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64666);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6514);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7734);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30724);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31567);
/* harmony import */ var components_ui_loading_indicator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13039);
/* harmony import */ var services_laravel_api_termsOfService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85013);









function AcceptanceTermsCheckbox(param) {
    var value = param.value, onChange = param.onChange, onAcceptedTerms = param.onAcceptedTerms;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value !== null && value !== void 0 ? value : false), hasAcceptedTerms = ref1[0], setHasAcceptedTerms = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isCallbackLoading = ref2[0], setIsCallbackLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), termsModalOpen = ref3[0], setTermsModalOpen = ref3[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)().t;
    var termsOfService = (0,services_laravel_api_termsOfService__WEBPACK_IMPORTED_MODULE_4__/* .useGetTermsOfServiceQuery */ .p8)(undefined, {
        refetchOnFocus: true
    });
    var isDisabled = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (termsOfService.error) {
            return true;
        }
        return isCallbackLoading || termsOfService.isLoading;
    }, [
        isCallbackLoading,
        termsOfService.isLoading,
        termsOfService.error
    ]);
    function handleOnChange(event) {
        return _handleOnChange.apply(this, arguments);
    }
    function _handleOnChange() {
        _handleOnChange = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(event) {
            var ref, value, termsVersion;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = event.target.checked;
                        termsVersion = (ref = termsOfService.data) === null || ref === void 0 ? void 0 : ref.version_tag;
                        if (!termsVersion) {
                            throw new Error("Terms of Service version is not available");
                        }
                        if (!(onAcceptedTerms && value)) return [
                            3,
                            2
                        ];
                        setIsCallbackLoading(true);
                        return [
                            4,
                            onAcceptedTerms(termsVersion).finally(function() {
                                return setIsCallbackLoading(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setHasAcceptedTerms(value);
                        if (onChange) {
                            onChange(value, termsVersion);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleOnChange.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    disabled: isDisabled,
                    sx: {
                        "&.Mui-disabled": {
                            color: function(theme) {
                                return theme.palette.custom.text.lightGrey;
                            }
                        }
                    },
                    checked: hasAcceptedTerms,
                    onChange: handleOnChange,
                    name: "termsAccepted",
                    color: "primary"
                }),
                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "body2",
                            children: [
                                "I have read and agree to the",
                                " ",
                                t("terms_and_services_name"),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    component: "button",
                                    type: "button",
                                    variant: "body2",
                                    disabled: isCallbackLoading,
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setTermsModalOpen(true);
                                    },
                                    sx: {
                                        verticalAlign: "baseline"
                                    },
                                    children: "Terms of Service"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui_loading_indicator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            isLoading: isCallbackLoading || termsOfService.isLoading,
                            size: 16
                        })
                    ]
                }),
                sx: {
                    mt: 2
                }
            }),
            termsOfService.isLoading === false && termsOfService.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                sx: {
                    mb: 1
                },
                severity: "error",
                children: "Failed to load Terms of Service."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                open: termsModalOpen,
                onClose: function() {
                    return setTermsModalOpen(false);
                },
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        children: "Terms & Services"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        dividers: true,
                        children: [
                            termsOfService.isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                sx: {
                                    alignItems: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    height: 100
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui_loading_indicator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    isLoading: true,
                                    size: 32
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
                                children: (ref = termsOfService.data) === null || ref === void 0 ? void 0 : ref.content
                            }),
                            termsOfService.isLoading === false && termsOfService.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                children: "Failed to load Terms of Service."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            onClick: function() {
                                return setTermsModalOpen(false);
                            },
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 33149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GuestGuard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hooks_use_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89731);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92268);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);







var GuestGuard = function(props) {
    var children = props.children;
    var auth = (0,_hooks_use_auth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    var settings = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)().settings;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), checked = ref[0], setChecked = ref[1];
    var disableGuard = router.query.disableGuard;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        // You should remove the "disableGuard" check, because it's meant to be used only in the demo.
        if (auth.isAuthenticated && disableGuard !== "true") {
            router.push("/dashboard");
        } else {
            setChecked(true);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.isReady
    ]);
    if (!checked) {
        return null;
    }
    // If got here, it means that the redirect did not occur, and that tells us that the user is
    // not authenticated / authorized.
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "theme-".concat(settings.theme),
        children: children
    });
};
GuestGuard.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
};


/***/ }),

/***/ 11901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16628);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84808);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    var show = props.show, fade = props.fade;
    if (fade) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: show,
            style: {
                transitionDelay: show ? "175ms" : "600ms"
            },
            unmountOnExit: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    color: "#fff",
                    zIndex: function(theme) {
                        return theme.zIndex.drawer + 1;
                    }
                },
                open: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    color: "inherit"
                })
            })
        });
    }
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            color: "#fff",
            zIndex: function(theme) {
                return theme.zIndex.drawer + 1;
            }
        },
        open: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            color: "inherit"
        })
    });
}));


/***/ }),

/***/ 13039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingIndicator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16628);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98456);




/**
 * Displays a loading indicator with optional box and delay.
 *
 * @param {boolean} isLoading - Determines if the loading indicator should be displayed.
 * @param {boolean} withBox - If true, wraps the indicator in a full-screen box.
 * @param {boolean} darkBackground - If true, uses a dark background for the box.
 * @param {boolean} withoutDelay - If true, shows the indicator without transition delay.
 * @param {...object} rest - Additional props passed to the CircularProgress component.
 * @returns {JSX.Element} A React component displaying a loading indicator.
 */ function LoadingIndicator(_param) {
    var isLoading = _param.isLoading, withBox = _param.withBox, darkBackground = _param.darkBackground, withoutDelay = _param.withoutDelay, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "isLoading",
        "withBox",
        "darkBackground",
        "withoutDelay"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        in: isLoading,
        style: {
            transitionDelay: isLoading && !withoutDelay ? "100ms" : "0ms"
        },
        unmountOnExit: true,
        children: withBox ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            sx: {
                position: "fixed",
                zIndex: 9999,
                width: "100%",
                height: "100vh",
                top: 0,
                left: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: darkBackground ? "rgba(0,0,0, 0.2)" : "rgba(255,255,255,0.5)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: "loader"
            }, rest))
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: "loader"
        }, rest))
    });
}


/***/ }),

/***/ 7792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50135);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81901);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_international_phone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43641);
/* harmony import */ var react_international_phone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_international_phone__WEBPACK_IMPORTED_MODULE_2__);






var MuiPhone = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var value = _param.value, onChange = _param.onChange, onCountryChange = _param.onCountryChange, defaultCountry = _param.defaultCountry, selectedCountry = _param.selectedCountry, selectedCountries = _param.selectedCountries, label = _param.label, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "value",
        "onChange",
        "onCountryChange",
        "defaultCountry",
        "selectedCountry",
        "selectedCountries",
        "label"
    ]);
    var countries = react_international_phone__WEBPACK_IMPORTED_MODULE_2__.defaultCountries.filter(function(defaultCountryItem) {
        return selectedCountries ? selectedCountries.indexOf(defaultCountryItem[1]) != -1 : true;
    });
    var ref = (0,react_international_phone__WEBPACK_IMPORTED_MODULE_2__.usePhoneInput)({
        defaultCountry: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.toLocaleLowerCase(),
        value: value,
        countries: countries,
        onChange: function(data) {
            onChange(data.phone);
        }
    }), phone = ref.phone, handlePhoneValueChange = ref.handlePhoneValueChange, country = ref.country, inputRef = ref.inputRef, setCountry = ref.setCountry;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        variant: "outlined",
        label: label ? label : null,
        placeholder: "Phone number",
        color: "primary",
        fullWidth: true,
        value: phone,
        onChange: handlePhoneValueChange,
        type: "tel",
        inputRef: inputRef,
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                position: "start",
                style: {
                    marginRight: "12px",
                    marginLeft: "4px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    MenuProps: {
                        style: {
                            height: "300px",
                            width: "360px",
                            top: "10px",
                            left: "-34px"
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                        }
                    },
                    sx: {
                        width: "max-content",
                        // Remove default outline (display only on focus)
                        fieldset: {
                            display: "none"
                        },
                        '&.Mui-focused:has(div[aria-expanded="false"])': {
                            fieldset: {
                                display: "block"
                            }
                        },
                        // Update default spacing
                        ".MuiSelect-select": {
                            padding: "8px",
                            paddingRight: "24px !important"
                        },
                        svg: {
                            right: 0
                        }
                    },
                    value: country,
                    onChange: function(e) {
                        var newCountry = e.target.value;
                        setCountry(newCountry);
                        var countryData = (0,react_international_phone__WEBPACK_IMPORTED_MODULE_2__.parseCountry)(countries.find(function(c) {
                            return (0,react_international_phone__WEBPACK_IMPORTED_MODULE_2__.parseCountry)(c).iso2 === newCountry;
                        }));
                        var newPhone = "+".concat(countryData.dialCode);
                        onChange(newPhone);
                        if (onCountryChange) {
                            onCountryChange(newCountry);
                        }
                    },
                    renderValue: function(value) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_international_phone__WEBPACK_IMPORTED_MODULE_2__.FlagEmoji, {
                            iso2: value,
                            style: {
                                display: "flex"
                            }
                        });
                    },
                    children: countries.map(function(c) {
                        var countryData = (0,react_international_phone__WEBPACK_IMPORTED_MODULE_2__.parseCountry)(c);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            value: countryData.iso2,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_international_phone__WEBPACK_IMPORTED_MODULE_2__.FlagEmoji, {
                                    iso2: countryData.iso2,
                                    style: {
                                        marginRight: "8px"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    marginRight: "8px",
                                    children: countryData.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    color: "gray",
                                    children: [
                                        "+",
                                        countryData.dialCode
                                    ]
                                })
                            ]
                        }, countryData.iso2);
                    })
                })
            })
        }
    }, restProps));
});
/* harmony default export */ __webpack_exports__["Z"] = (MuiPhone);


/***/ }),

/***/ 92268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48473);


var useSettings = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .SettingsContext */ .J6);
};


/***/ }),

/***/ 36747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ register_html; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/components/HeaderTitle.js
var HeaderTitle = __webpack_require__(50945);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./src/components/authentication/guest-guard.js
var guest_guard = __webpack_require__(33149);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./node_modules/yup-phone/dist/yup-phone.umd.js
var yup_phone_umd = __webpack_require__(48269);
// EXTERNAL MODULE: ./src/store/index.js + 1 modules
var store = __webpack_require__(66605);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(85200);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/AlertTitle/AlertTitle.js + 1 modules
var AlertTitle = __webpack_require__(92401);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(47312);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(81901);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(7734);
// EXTERNAL MODULE: ./src/hooks/use-auth.js
var use_auth = __webpack_require__(89731);
// EXTERNAL MODULE: ./src/hooks/use-mounted.js
var use_mounted = __webpack_require__(46723);
// EXTERNAL MODULE: ./src/lib/gtm.js
var gtm = __webpack_require__(38682);
// EXTERNAL MODULE: ./src/components/saving-bar.js
var saving_bar = __webpack_require__(11901);
// EXTERNAL MODULE: ./src/store/selectors/settings.js
var settings = __webpack_require__(18851);
// EXTERNAL MODULE: ./src/components/widgets/PhoneNumber.js
var PhoneNumber = __webpack_require__(7792);
// EXTERNAL MODULE: ./src/components/authentication/acceptance-terms-checkbox.tsx
var acceptance_terms_checkbox = __webpack_require__(76297);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(25570);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
;// CONCATENATED MODULE: ./src/components/authentication/jwt-register.js


























/*
Frontend:
<script>
  function setCampaignCookie() {
      if (window.location.search.match(/utm_campaign/i) == null) return false;

      setCookie('rads_marketing_ref', window.location.search, 60)
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain="+ window.location.host.replace('www.', '.') +";path=/";
  }

  setCampaignCookie();
</script>

*/ var JWTRegister = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "cmpmrf",
        "rads_marketing_ref"
    ]), 2), cookies = ref[0], setCookie = ref[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isMounted = (0,use_mounted/* useMounted */.s)();
    var router = (0,next_router.useRouter)();
    var register = (0,use_auth/* useAuth */.a)().register;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var defaultCountry = settings/* default.getDefaultCountry */.Z.getDefaultCountry();
    var availableCountries = settings/* default.getAvilableFormCountries */.Z.getAvilableFormCountries();
    var userProfileCountries = settings/* default.getUserProfileCountries */.Z.getUserProfileCountries();
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            first_name: router.query.hasOwnProperty("usr_first_name") ? router.query.usr_first_name : "",
            last_name: router.query.hasOwnProperty("usr_last_name") ? router.query.usr_last_name : "",
            email: router.query.hasOwnProperty("usr_email") ? router.query.usr_email : "",
            phone_number: "",
            password: "",
            password_re: "",
            company_name: router.query.hasOwnProperty("usr_company_name") ? router.query.usr_company_name : "",
            company_url: "",
            policy: false,
            version_tag: "",
            submit: null,
            token: null,
            country_code: defaultCountry ? defaultCountry.code : "US",
            reg_step_1: false,
            reg_step_2: false,
            reg_step_3: false,
            reg_step_4: false
        },
        initialStatus: {
            success: false
        },
        //(479) 883-2288
        //704-467-0795
        validationSchema: es.object({
            first_name: es.string().max(50).required("Field is required"),
            last_name: es.string().max(50).required("Field is required"),
            company_name: es.string().max(80).required("Field is required"),
            // token: Yup.string().max(255).required("Google Recaptcha Required"),
            email: es.string().email("Must be a valid email").max(255).required("Email is required"),
            phone_number: es.string().required("Cell Phone Number is required").test("phone-validation", "Please provide a valid phone number.", function(value) {
                if (!value) return false;
                if (!value.startsWith("+")) return false;
                var digitsOnly = value.replace(/\D/g, "");
                if (digitsOnly.length < 8) return false;
                var countryCode = this.parent.country_code;
                if (!countryCode) return false;
                try {
                    var phoneSchema = es.string().phone(countryCode, true);
                    phoneSchema.validateSync(value);
                    return true;
                } catch (error) {
                    try {
                        var phoneSchemaLoose = es.string().phone(countryCode, false);
                        phoneSchemaLoose.validateSync(value);
                        return true;
                    } catch (error2) {
                        return false;
                    }
                }
            }),
            password: es.string().min(7, "Must be more than 7 characters").max(255).required("Password is required"),
            password_re: es.string().min(7, "Must be more than 7 characters").max(255).required("Password is required").oneOf([
                es.ref("password"),
                null
            ], "Passwords must match"),
            policy: es.boolean().oneOf([
                true
            ], "You need to approve Terms and Conditions"),
            version_tag: es.string().required("Terms version is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values, helpers) {
                var token, invite_ref_id, reg_cookie, ref, errorMessage, user, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                handleReCaptchaVerify()
                            ];
                        case 1:
                            token = _state.sent();
                            invite_ref_id = router.query.r;
                            if (!token) {
                                helpers.setStatus({
                                    success: false
                                });
                                helpers.setErrors({
                                    formError: "Unexpected Google ReCaptcha. Please reload your page and try again."
                                });
                                helpers.setSubmitting(false);
                                return [
                                    2
                                ];
                            }
                            reg_cookie = cookies["rads_marketing_ref"] ? cookies["rads_marketing_ref"] : null;
                            reg_cookie = cookies["cmpmrf"] ? cookies["cmpmrf"] : null;
                            return [
                                4,
                                register(values.first_name, values.last_name, values.phone_number, values.email, values.password, values.company_name, values.company_url, token, reg_cookie, invite_ref_id, values.country_code, values.version_tag)
                            ];
                        case 2:
                            ref = _state.sent(), errorMessage = ref.errorMessage, user = ref.user;
                            if (isMounted() && user) {
                                gtm/* gtm.push */.w.push({
                                    event: "userinfo",
                                    event_action: "update",
                                    first_name: values.first_name,
                                    last_name: values.last_name,
                                    email: values.email,
                                    phone_number: values.phone_number,
                                    company_name: values.company_name,
                                    company_url: values.company_url
                                });
                                sessionStorage.setItem("username", values.email);
                                gtm/* gtm.push */.w.push({
                                    event: "rads_event",
                                    event_category: "user",
                                    event_action: "onAccountRegister",
                                    event_label: "success"
                                });
                                router.push("/authentication/verify-code.html");
                            } else {
                                helpers.setStatus({
                                    success: false
                                });
                                helpers.setErrors({
                                    formError: errorMessage
                                });
                                helpers.setSubmitting(false);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            if (isMounted()) {
                                helpers.setStatus({
                                    success: false
                                });
                                helpers.setErrors({
                                    formError: err.message
                                });
                                helpers.setSubmitting(false);
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, helpers) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var selectedCountry = availableCountries.find(function(availableCountry) {
        return availableCountry.code == formik.values.country_code;
    });
    // Create an event handler so you can call the verification on button click event or form submit
    var handleReCaptchaVerify = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var token;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!executeRecaptcha) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        executeRecaptcha("signup")
                    ];
                case 1:
                    token = _state.sent();
                    // Do whatever you want with the token
                    formik.setFieldValue("token", token);
                    return [
                        2,
                        token
                    ];
            }
        });
    }), [
        executeRecaptcha,
        isMounted
    ]);
    // You can use useEffect to trigger the verification as soon as the component being loaded
    (0,react.useEffect)(function() {
        handleReCaptchaVerify();
    }, [
        handleReCaptchaVerify
    ]);
    var handleCountryChange = function(event) {
        var newCountryCode = event.target.value;
        var dialCodeMap = {
            US: "+1",
            GB: "+44",
            CH: "+41"
        };
        var dialCode = dialCodeMap[newCountryCode] || "";
        formik.setFieldValue("country_code", newCountryCode);
        formik.setFieldValue("phone_number", dialCode);
    };
    if (formik.status.success) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                mb: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                severity: "success",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTitle/* default */.Z, {
                        children: "Account created!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Please check your email to verify your account."
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        noValidate: true,
        onSubmit: formik.handleSubmit
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(saving_bar/* default */.Z, {
                show: formik.isSubmitting
            }),
            formik.errors.formError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: formik.errors.formError
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                style: {
                    marginTop: 32
                },
                children: "Contact Details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.first_name && formik.errors.first_name),
                fullWidth: true,
                required: true,
                autoComplete: "given-name",
                helperText: formik.touched.first_name && formik.errors.first_name,
                label: "First Name",
                margin: "normal",
                name: "first_name",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                value: formik.values.first_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.last_name && formik.errors.last_name),
                fullWidth: true,
                required: true,
                autoComplete: "family-name",
                helperText: formik.touched.last_name && formik.errors.last_name,
                label: "Last Name",
                margin: "normal",
                name: "last_name",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                value: formik.values.last_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.email && formik.errors.email),
                fullWidth: true,
                required: true,
                autoComplete: "email",
                helperText: formik.touched.email && formik.errors.email,
                label: "Email Address",
                margin: "normal",
                name: "email",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "email",
                value: formik.values.email
            }),
            availableCountries.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                fullWidth: true,
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                        id: "demo-simple-select-label",
                        children: "Target Country"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                        labelId: "demo-simple-select-label",
                        id: "demo-simple-select",
                        value: formik.values.country_code,
                        label: "Target Country",
                        name: "country_code",
                        onBlur: formik.handleBlur,
                        onChange: handleCountryChange,
                        children: availableCountries.map(function(availableCountry) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: availableCountry.code,
                                children: availableCountry.name
                            }, "country_code_".concat(availableCountry.name));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumber/* default */.Z, {
                label: "Phone Number",
                selectedCountry: formik.values.country_code.toLocaleLowerCase(),
                defaultCountry: formik.values.country_code.toLocaleLowerCase(),
                value: formik.values.phone_number,
                onBlur: formik.handleBlur,
                name: "phone_number",
                onChange: function(newPhoneNumber) {
                    return formik.setFieldValue("phone_number", newPhoneNumber);
                },
                onCountryChange: function(newCountry) {
                    return formik.setFieldValue("country_code", newCountry.toUpperCase());
                },
                error: Boolean(formik.touched.phone_number && formik.errors.phone_number),
                helperText: formik.touched.phone_number && formik.errors.phone_number,
                sx: {
                    mt: 3
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                style: {
                    marginTop: 32
                },
                children: "Company or Organization"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.company_name && formik.errors.company_name),
                fullWidth: true,
                required: true,
                autoComplete: "organization",
                helperText: formik.touched.company_name && formik.errors.company_name,
                label: "Company or Organization Name",
                margin: "normal",
                name: "company_name",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "text",
                value: formik.values.company_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.company_url && formik.errors.company_url),
                fullWidth: true,
                autoComplete: "url",
                helperText: formik.touched.company_url && formik.errors.company_url,
                label: "Company or Organization URL",
                margin: "normal",
                name: "company_url",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "text",
                value: formik.values.company_url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                style: {
                    marginTop: 32
                },
                children: "Password"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.password && formik.errors.password),
                fullWidth: true,
                required: true,
                helperText: formik.touched.password && formik.errors.password,
                label: "Password",
                margin: "normal",
                name: "password",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "password",
                value: formik.values.password
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                error: Boolean(formik.touched.password_re && formik.errors.password_re),
                helperText: formik.touched.password_re && formik.errors.password_re,
                fullWidth: true,
                required: true,
                label: "Repeat Password",
                margin: "normal",
                name: "password_re",
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                type: "password",
                value: formik.values.password_re
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                style: {
                    marginTop: 32
                },
                children: "Registration steps"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                severity: "info",
                sx: {
                    mt: 2,
                    mb: 1
                },
                children: "Please tick the checkboxes to confirm the registration process"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    ml: -1,
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: formik.values.reg_step_1,
                        name: "reg_step_1",
                        onChange: formik.handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        color: "textSecondary",
                        variant: "body2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Step 1"
                            }),
                            " - To verify your account, an email will be sent to the address you provide. Please remember to check your spam folder in case the email gets filtered there."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    ml: -1,
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: formik.values.reg_step_2,
                        name: "reg_step_2",
                        onChange: formik.handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        color: "textSecondary",
                        variant: "body2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Step 2"
                            }),
                            " - Before you can access all the features available on the platform, our team will review and approve your account. Reviews usually take less than 24 hours."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    ml: -1,
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        disabled: true,
                        checked: true,
                        name: "reg_step_3",
                        onChange: formik.handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        color: "textSecondary",
                        variant: "body2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Step 3"
                            }),
                            " - Once your account is approved, you'll receive an email with the confirmation."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                style: {
                    marginTop: 32
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(acceptance_terms_checkbox/* default */.Z, {
                value: formik.values.policy,
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(hasAccepted, termsVersion) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), {
                                            policy: hasAccepted,
                                            version_tag: termsVersion
                                        }), true)
                                    ];
                                case 1:
                                    _state.sent();
                                    formik.setFieldTouched("policy", true, false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(hasAccepted, termsVersion) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            Boolean(formik.touched.policy && !formik.values.policy && formik.errors.policy) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                sx: {
                    ml: 2,
                    mt: 1
                },
                children: formik.errors.policy
            }),
            formik.errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                    error: true,
                    children: formik.errors.submit
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: formik.isSubmitting || !formik.isValid || !formik.values.policy,
                    fullWidth: true,
                    size: "large",
                    type: "submit",
                    variant: "contained",
                    children: "Register"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    mt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    color: "textSecondary",
                    variant: "body2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Need Help?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "If you have any questions or need assistance, please feel free to reach out to",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:".concat(t("support_contact_email")),
                            children: t("support_contact_email")
                        }),
                        ". We will be happy to help and provide the necessary support."
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/theme-logo.js
var theme_logo = __webpack_require__(81759);
// EXTERNAL MODULE: ./src/hooks/use-settings.js
var use_settings = __webpack_require__(92268);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(33726);
;// CONCATENATED MODULE: ./src/pages/authentication/register.html.js
















var Register = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var settings = (0,use_settings/* useSettings */.r)().settings;
    var router = (0,next_router.useRouter)();
    var disableGuard = router.query.disableGuard;
    (0,react.useEffect)(function() {
        gtm/* gtm.push */.w.push({
            event: "page_view"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle/* default */.Z, {
                children: "Register"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                reCaptchaKey: config/* siteConfig.recaptchaKey */.JA.recaptchaKey,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "main",
                    sx: {
                        backgroundColor: "background.default",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "100vh"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "sm",
                        sx: {
                            py: {
                                xs: "60px",
                                md: "120px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                            elevation: 16,
                            sx: {
                                p: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        alignItems: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_logo/* default */.Z, {
                                                    variant: settings.theme,
                                                    sx: {
                                                        height: "auto",
                                                        width: "230px"
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            style: {
                                                marginTop: 30
                                            },
                                            children: "Register"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "textSecondary",
                                            sx: {
                                                mt: 2
                                            },
                                            variant: "body2",
                                            children: "Register on the internal platform"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        flexGrow: 1,
                                        mt: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JWTRegister, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    sx: {
                                        my: 3
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: disableGuard ? "/authentication/login.html?disableGuard=".concat(disableGuard) : "/authentication/login.html",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        color: "textSecondary",
                                        variant: "body2",
                                        children: "Go back to Log In"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
Register.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(guest_guard/* GuestGuard */.A, {
        children: page
    });
};
/* harmony default export */ var register_html = (Register);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3234,5294,6135,135,5200,7258,1664,7444,3641,5391,9774,2888,179], function() { return __webpack_exec__(54575); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);